import React, { useState } from "react";
import { Box, Divider } from "@mui/material";
import Query from "./Query";
import MessageTabs from "./MessageTabs";
import Answer from "./Answer/Answer";
import SourcesList from "../../../../../AI_Search/AI_Search/components/SourcesList";

function Message({
  message,
  isStreaming,
  queryContainerHeight,
  isLastMessage,
  onIsolationMarkupChange,
  onSelectedIsolationMarkupChange,
}) {
  const [selectedTab, setSelectedTab] = useState("ai_answer");

  const handleClickTab = (tab) => {
    setSelectedTab(tab);
  };

  return (
    <Box
      sx={{
        minHeight:
          isLastMessage && !isStreaming
            ? `calc(100vh - ${188 + queryContainerHeight}px)`
            : "inherit",
      }}>
      <Box
        sx={{
          position: "sticky",
          top: -8,
          zIndex: 999,
          background: (theme) => theme.palette.background.default,
          pt: 1,
        }}>
        <Query query={message["query"]} />
        <MessageTabs
          message={message}
          selectedTab={selectedTab}
          handleClickTab={handleClickTab}
        />
        <Divider />
        <Box mb={2} />
      </Box>
      {selectedTab === "ai_answer" && (
        <Answer
          answer={message["answer"]}
          onIsolationMarkupChange={onIsolationMarkupChange}
          onSelectedIsolationMarkupChange={onSelectedIsolationMarkupChange}
        />
      )}
      {selectedTab === "sources" && <SourcesList message={message} />}
      {(!isLastMessage || isStreaming) && <Box mb={8} />}
    </Box>
  );
}

export default Message;
